"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_PADDING = exports.TEXT_MEDIUM_HEIGHT = exports.TEXT_MEDIUM_FONT_SIZE = exports.TEXT_MEDIUM_BUTTON_SIZE = exports.TEXT_LARGE_HEIGHT = exports.MEDIUM_MIN_WIDTH = exports.MEDIUM_INPUT_WIDTH = exports.LARGE_MIN_WIDTH = exports.LARGE_INPUT_WIDTH = exports.LARGE_FONT_SIZE = exports.LARGE_BUTTON_SIZE = exports.INPUT_FONT_SIZE = exports.DEFAULT_MIN_VALUE = exports.DEFAULT_MAX_VALUE = exports.CONTAINED_PADDING = exports.CONTAINED_MEDIUM_HEIGHT = exports.CONTAINED_MEDIUM_FONT_SIZE = exports.CONTAINED_MEDIUM_BUTTON_SIZE = exports.CONTAINED_MEDIUM_BUTTON_MIN_HEIGHT = exports.CONTAINED_LARGE_HEIGHT = exports.CONTAINED_LARGE_BUTTON_MIN_HEIGHT = void 0;
const MEDIUM_MIN_WIDTH = exports.MEDIUM_MIN_WIDTH = 106;
const LARGE_MIN_WIDTH = exports.LARGE_MIN_WIDTH = 130;
const TEXT_MEDIUM_HEIGHT = exports.TEXT_MEDIUM_HEIGHT = 3;
const CONTAINED_MEDIUM_HEIGHT = exports.CONTAINED_MEDIUM_HEIGHT = 3.5;
const TEXT_LARGE_HEIGHT = exports.TEXT_LARGE_HEIGHT = 3.5;
const CONTAINED_LARGE_HEIGHT = exports.CONTAINED_LARGE_HEIGHT = 4.5;
const TEXT_MEDIUM_BUTTON_SIZE = exports.TEXT_MEDIUM_BUTTON_SIZE = '3rem';
const CONTAINED_MEDIUM_BUTTON_SIZE = exports.CONTAINED_MEDIUM_BUTTON_SIZE = '2.5rem';
const LARGE_BUTTON_SIZE = exports.LARGE_BUTTON_SIZE = '3.5rem';
const MEDIUM_INPUT_WIDTH = exports.MEDIUM_INPUT_WIDTH = '3rem';
const LARGE_INPUT_WIDTH = exports.LARGE_INPUT_WIDTH = '4rem';
const TEXT_PADDING = exports.TEXT_PADDING = '0rem';
const CONTAINED_PADDING = exports.CONTAINED_PADDING = '0.5rem';
const CONTAINED_MEDIUM_BUTTON_MIN_HEIGHT = exports.CONTAINED_MEDIUM_BUTTON_MIN_HEIGHT = '3.5rem';
const CONTAINED_LARGE_BUTTON_MIN_HEIGHT = exports.CONTAINED_LARGE_BUTTON_MIN_HEIGHT = '4.5rem';
const TEXT_MEDIUM_FONT_SIZE = exports.TEXT_MEDIUM_FONT_SIZE = '1.8rem';
const CONTAINED_MEDIUM_FONT_SIZE = exports.CONTAINED_MEDIUM_FONT_SIZE = '1.9rem';
const LARGE_FONT_SIZE = exports.LARGE_FONT_SIZE = '2.3rem';
const INPUT_FONT_SIZE = exports.INPUT_FONT_SIZE = '1.6rem';
const DEFAULT_MIN_VALUE = exports.DEFAULT_MIN_VALUE = 0;
const DEFAULT_MAX_VALUE = exports.DEFAULT_MAX_VALUE = Number.POSITIVE_INFINITY;
